<footer class="footer" [style.display]="headLess ? 'none' : 'block'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">{{ year }} © TSOLife.</div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          Designed & Developed by TSOLife
        </div>
      </div>
    </div>
  </div>
</footer>
